import artifact from '$houdini/artifacts/UpdateGroup'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateGroupStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
